import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, setRefreshToken, removeToken, removeRefreshToken } from '@/utils/auth'
import md5 from 'js-md5'

const user = {
  state: {
    token: getToken(),
    refresh_token: '',
    id: '',
    customerId: '',
    name: '',
    avatar: '',
    roles: [],
    userType:''
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_REFRESH_TOKEN: (state, token) => {
      state.refresh_token = token
    },
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_CUSTOMER_ID: (state, customerId) => {
      state.customerId = customerId
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_USER_TYPE: (state, userType) => {
      state.userType = userType
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo.customerCode.trim() + ',' + userInfo.userName.trim(), md5(md5(userInfo.password) + userInfo.password)).then(response => {
          const data = response
          setToken(data.access_token)
          setRefreshToken(data.refresh_token)
          commit('SET_TOKEN', data.access_token)
          commit('SET_REFRESH_TOKEN', data.refresh_token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token).then(response => {
          const data = response
          if (data.customerRoles && data.customerRoles.length > 0) { // 验证返回的roles是否是一个非空数组
            const roles = data.customerRoles.map(role => { return role.code })
            commit('SET_ROLES', roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_ID', data.id)
          commit('SET_CUSTOMER_ID', data.customerId)
          commit('SET_NAME', data.name)
          commit('SET_AVATAR', data.avatar)
          commit('SET_USER_TYPE',data.userType)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token, state.refresh_token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_REFRESH_TOKEN', '')
          commit('SET_ROLES', [])
          //  removeToken()
          //  removeRefreshToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user
